import { HttpErrorResponse, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, from, switchMap } from 'rxjs';

import { AuthService } from '@services/auth/auth.service';

const apiDomain = 'solucionaqui.com';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  return from(authService.getToken()).pipe(
    switchMap((accessToken) => {
      const Authorization = `Bearer ${accessToken}`;

      if (isApiRoute(req.url) && accessToken && !isAuthRoute(req.url)) {
        req = setHeaders(req, Authorization);
      }

      return next(req).pipe(
        catchError((err: unknown) => {
          if (err instanceof HttpErrorResponse && err.status === 401 && !isAuthRoute(req.url) && accessToken) {
            void authService.signOut();
          }

          throw err;
        })
      );
    })
  );
};

const setHeaders = (req: HttpRequest<unknown>, Authorization: string) => {
  return req.clone({
    setHeaders: {
      Authorization,
    },
  });
};

const isAuthRoute = (url: string) => url.includes('/auth/sign-in') || url.includes('/auth/sign-up');

const isApiRoute = (url: string): boolean => {
  try {
    const { hostname } = new URL(url);
    return hostname === apiDomain || hostname.endsWith(`.${apiDomain}`);
  } catch {
    return false;
  }
};
